/**
 * Positioning directions for the listbox when a select is open.
 * @public
 */
export const SelectPosition = {
    above: "above",
    below: "below",
};
